import { ReactNode } from 'react';
import { Box, Button, Typography, type ButtonProps } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import PlanRecommendationLoading from '@/assets/gifs/loading-walk.gif';

interface ProcessingLoadingProps {
  title: string;
  description: string;
  button?: ButtonProps & { children: ReactNode };
}

export const ProcessingLoading = ({
  title,
  description,
  button,
}: ProcessingLoadingProps) => {
  return (
    <ContentBox
      gap={2}
      alignItems={{ md: 'center' }}
      justifyContent={{ md: 'center' }}
      textAlign={{ md: 'center' }}
      py={4}
    >
      <Box
        component="img"
        src={PlanRecommendationLoading}
        sx={{ width: 128 }}
        alt=""
      />
      <Typography fontWeight={700}>{title}</Typography>
      <Typography>{description}</Typography>
      {button && (
        <Box mt={3}>
          <Button onClick={button.onClick} variant={button.variant}>
            {button.children}
          </Button>
        </Box>
      )}
    </ContentBox>
  );
};
